<template>
    <div>

    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        computed: {
            ...mapGetters(["allMessages"]),
        },
        watch: {
            allMessages(){
                let ionic = this.$ionic;
                this.allMessages.forEach(function(message) {
                    ionic.alertController
                        .create({
                            // header: 'Alert',
                            // subHeader: 'Subtitle',
                            message: message.title,
                            buttons: ['OK'],
                        })
                        .then(a => a.present())
                });

            }
        }
    }
</script>
